<template>
  <div class="main">
    <isheader></isheader>
    <div class="mian-section">
      <isnav></isnav>
      <div class="hide">
        <div class="scroll">
          <div class="wrap">
            <el-breadcrumb separator="/">
              <template v-for="(val, idx) in breadList">
                <el-breadcrumb-item :key="idx" v-if="val.meta.title">{{
                  val.meta.title
                }}</el-breadcrumb-item>
              </template>
            </el-breadcrumb>
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import isheader from "../components/isheader.vue";
import isnav from "../components/IsNav.vue";

export default {
  data() {
    return {
      breadList: []
    };
  },
  watch: {
    $route() {
      //监听$route
      this.getBreadcrumb();
    }
  },
  mounted() {},
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched;
      matched = [].concat(matched);
      this.breadList = matched;
    }
  },
  created() {
    //生命周期中调用获取数据的方法
    this.getBreadcrumb();
  },
  components: {
    isheader,
    isnav
  }
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .mian-section {
    // overflow: hidden;
    width: 100%;
    height: calc(100vh - .8rem);
    display: flex;
  }
  .hide {
    flex: 1;
    overflow-y: scroll;
    // height: calc(100vh - 0.8rem);
    // width: calc(100vw - 200px);
    // width: 100%;
    background: #f4f4f4;
  }
  .scroll {
    overflow: hidden;
    // height: calc(100vh - 0.8rem);
    // overflow-y: scroll;
    // width     : calc(100% + 0.2rem);
  }
}

>>> {
  .el-breadcrumb__item .el-breadcrumb__inner {
    font-size: 0.16rem;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/main.vue